import { useEffect, useMemo, useState } from 'react';

export const useKwRangeSelect = (range: [number, number] = [0, 10]) => {
  // this is needed because sometimes the range will be undefined initially during render
  range = useMemo(() => range, [range[0], range[1]]);

  const [value, setValue] = useState(range);

  const handleChange = newValue => {
    setValue(newValue);
  };

  // this is needed because sometimes the range will be undefined initially during render
  useEffect(() => {
    setValue([range[0], range[1]]);
  }, [range]);

  const reset = () => {
    setValue([range[0], range[1]]);
  };
  return {
    handleChange,
    value,
    range,
    reset,
  };
};
